import { z } from "zod";
import { MetaSchema } from "./shared";
import { TransferPaymentFineEnum } from "../enums";
import { LoanSchema } from "./shared/LoanSchema";
import { LoanTransactionSchema } from "./shared/LoanTransactionSchema";

export const UserLoanSchema = z.object({
  id: z.string().uuid(),
  uid: z.any(),
  startDate: z.string().datetime(),
  endDate: z.string().datetime(),
  paidInstallments: z.number(),
  status: z.string(),

  liquidityValue: z.string(),
  marginCallValue: z.string(),
  freeMarginValue: z.string(),

  amount: z.string(),
  targetLtv: z.string(),
  currentLtv: z.string(),
  remainingAmount: z.string(),

  reliability: z.string(),
  transferPaymentFineType:
    TransferPaymentFineEnum.transferPaymentFineTypeSchema,
  receivedCurrency: z.string(),

  initialCollateralPrice: z.string(),
  unpaidInstallments: z.number(),
  collateralAmount: z.string(),

  transferredAmount: z.string().nullable(),
  purpose: z.string().optional(),
  penalty: z.any().nullable(),

  monthlyRepay: z.string(),

  acceptedAt: z.string().nullable(),
  nextRepaymentDate: z.string().datetime(),
  lastInstallmentAt: z.string().nullable(),

  updatedAt: z.string().datetime(),
  createdAt: z.string().datetime(),

  loan: LoanSchema,

  loanTransactions: z.array(LoanTransactionSchema),
});

export const GetLoansUserDataSchema = z.tuple([
  z.array(UserLoanSchema),
  z.number(),
]);

const LoansUserResponse = z.object({
  data: GetLoansUserDataSchema,
  meta: MetaSchema.default,
});

export type LoanSchemaType = z.infer<typeof LoanSchema>;
export type LoansUserResponseType = z.infer<typeof UserLoanSchema>;
export default LoansUserResponse;
